import clsx from 'clsx';

/**
 * Company logo from Settings → Company (or the built-in PCBS logo).
 * `mark` = the letters only (menu); `full` = with the tagline (sign-in page).
 * `version` busts the browser cache after an administrator uploads a new logo.
 */
export function Logo({ variant = 'mark', className, version, alt = '' }: { variant?: 'mark' | 'full'; className?: string; version?: string; alt?: string }) {
  return <img src={`/api/meta/logo?variant=${variant}${version ? `&v=${version}` : ''}`} alt={alt} className={clsx('object-contain', className)} />;
}
